import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/mile/Projekti/ivanobazeni.hr/layouts/default.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/Users/mile/Projekti/nuxt-base/layouts/blank.vue").then(m => m.default || m)),
  bot: defineAsyncComponent(() => import("/Users/mile/Projekti/nuxt-base/layouts/bot.vue").then(m => m.default || m))
}